const initialState = {
    inputFullname: '',
    inputMobile: '',
    inputEmail: '',
    inputComment: '',
    attachFile: false,
    filePreview: null,
    onlyForm: false, // matnhaye zire form namayesh dade shavad ya kheyr
};
const surguryConsultation = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SURGURY_CONSULTATION':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default surguryConsultation;
